import { render } from "./UserCustomerSupportSavePartial.vue?vue&type=template&id=6476b996"
import script from "./UserCustomerSupportSavePartial.vue?vue&type=script&lang=js"
export * from "./UserCustomerSupportSavePartial.vue?vue&type=script&lang=js"
script.render = render

export default script